// @flow
import { delay } from '@src/common-utils/utils';
import { STREAM_GOVERNANCE_CONFIG_ARRAY_BACKEND_NAME } from '@src/constants';

import { DELAY_BETWEEN_MUTATIONS_MS, throwOnError } from './utils';

// Reshape streamGovernance into the nested structure the UI validation schema expects
// so that uniqueness and other form-level tests work correctly
export const reshapeSGForValidation = (jsonData) => ({
  ...jsonData,
  streamGovernance: jsonData.streamGovernance
    ? { [STREAM_GOVERNANCE_CONFIG_ARRAY_BACKEND_NAME]: jsonData.streamGovernance }
    : undefined,
});

export const createStreamGovernanceFromBaseline = async (
  sgItems,
  estimateId,
  currentVersion,
  createStreamGovernanceConfig
) => {
  let version = currentVersion;

  for (const sg of sgItems) {
    const payload = {
      environment_name: sg.environment_name,
      package: sg.package,
      provider_name: sg.provider_name,
      region_name: sg.region_name,
      schema_count: sg.schema_count,
      rules_count: sg.rules_count,
      estimate_version: version,
    };

    const { error, data } = await createStreamGovernanceConfig({
      estimateId,
      payload,
    });

    throwOnError(
      error,
      `creating stream governance "${sg.environment_name}" with inputs:\n\n${JSON.stringify(
        payload,
        null,
        2
      )}`
    );

    version = data.estimate_version;
    await delay(DELAY_BETWEEN_MUTATIONS_MS);
  }

  return version;
};
